import React, { useState } from "react";
import "./Contact.css";
import contactHero from "../assets/mission3.webp";

const Contact = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalToggle = () => setIsModalOpen(!isModalOpen);

  return (
    <div className="contact-page">
      {/* HERO SECTION */}
      <section
        className="contact-hero"
        style={{ backgroundImage: `url(${contactHero})` }}
      >
        <div className="contact-hero-overlay"></div>
        <div className="contact-hero-text">
          <h1>Want to get in touch?</h1>
          {/* <p>
            Please feel free to contact us using the information below! If we
            can answer any questions, schedule a tour, or help in any other way,
            we'd love to!
          </p> */}
        </div>
      </section>

      {/* TOUR SECTION */}
      <section className="tour-section">
        <div className="tour-info">
          <h2>Schedule a Tour</h2>
          <p>
            We’d love to meet you in person! Come see our space, meet our staff,
            and learn more about what we offer. Please call or email to schedule
            a tour or to learn more about how your child can become a part of this
            special place.
          </p>
        </div>
      </section>

      {/* CONTACT INFO */}
      <section className="contact-info">
        <div className="contact-text">
          <h2>Contact Information</h2>
          <p><strong>Address:</strong> 1712 Willow Dr, Chapel Hill, NC 27514</p>
          <p><strong>Phone:</strong> (919) 968-1427</p>
          <p><strong>Director:</strong> Kim Buckley</p>
          <button className="primary-btn" onClick={handleModalToggle}>
            Email Our Director
          </button>
        </div>
      </section>

      {/* MAP SECTION */}
      <section className="map-section">
        <h2>Find Us</h2>
        <div className="map-container">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3230.7251070351695!2d-79.0281201234671!3d35.9292280725082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89acc2ac7fa892c1%3A0xd216cab24038fc1e!2sBinkley%20Preschool!5e0!3m2!1sen!2sus!4v1756304196096!5m2!1sen!2sus"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        <button
          className="secondary-btn"
          onClick={() =>
            window.open(
              "https://www.google.com/maps/place/Binkley+Preschool/@35.9292281,-79.0281201,17z/data=!3m1!4b1!4m6!3m5!1s0x89acc2ac7fa892c1:0xd216cab24038fc1e!8m2!3d35.9292281!4d-79.0255452!16s%2Fg%2F1vnrrgxq",
              "_blank"
            )
          }
        >
          View on Google Maps
        </button>
      </section>

      {/* MODAL */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={handleModalToggle} role="dialog" aria-modal="true">
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>Send a Message to Our Director</h2>
            <form
              action="https://formspree.io/f/mgvpyvzw"
              method="POST"
              className="contact-form"
            >
              <label>
                Your Name
                <input type="text" name="name" required aria-required="true" />
              </label>
              <label>
                Your Email
                <input type="email" name="_replyto" required aria-required="true" />
              </label>
              <label>
                Message
                <textarea name="message" rows="5" required aria-required="true"></textarea>
              </label>
              <button type="submit" className="primary-btn">Send Message</button>
              <button type="button" className="secondary-btn" onClick={handleModalToggle}>
                Close
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contact;
